import { GraphQLError } from 'graphql'

export const isTokenExpiredError = (graphQLErrors: ReadonlyArray<GraphQLError>) => {
  return graphQLErrors[0].extensions?.code === 'TOKEN_IS_EXPIRED'
}
